<div class="flex justify-between items-center" mat-dialog-title>

  <button (click)="download()" color="accent" mat-button>
    <mat-icon svgIcon="mat_outline:cloud_download"></mat-icon>
  </button>
  <h2>{{ data?.title }}</h2>
  <button *ngIf="!dataViaInput" [mat-dialog-close]="true" mat-button>
    <mat-icon svgIcon="mat_outline:close"></mat-icon>
  </button>
</div>

<mat-dialog-content>
  <ngx-doc-viewer
    (loaded)="isLoading = false;"
    *ngIf="data?.type !== 'PDF'"
    [url]="data?.url"
    style="width:100%;height:60vh;"
    viewer="google"
  ></ngx-doc-viewer>

  <pdf-viewer
    (after-load-complete)="isLoading = false;"
    *ngIf="data?.type === 'PDF'"
    [src]="data?.url"
    style="width:100%;height:60vh;"
  ></pdf-viewer>


</mat-dialog-content>

<mat-spinner *ngIf="isLoading" class="absolute top-1/2 right-1/2"></mat-spinner>
